import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import SignaturePad from "signature_pad";
import { FormsService } from "src/app/services/forms.service";
import { ToastService } from "src/app/services/toast.service";

@Component({
    selector: "app-signature",
    templateUrl: "./signature.component.html",
    styleUrls: ["./signature.component.scss"],
    standalone: false,
})
export class Signature implements OnInit, AfterViewInit {
    @ViewChild("canvas") canvasEl!: ElementRef;
    @Input() labelContent: string;
    @Input() formTemplateFieldId: string;

    // We will be needing these so we can replace the view of the SVG,
    // since there is no adequate ng signature library :)
    private widthPattern: RegExp = /width="[\s\d\w.]+"/m;
    private heightPattern: RegExp = /height="[\s\d\w.]+"/m;
    private viewBoxPattern: RegExp = /viewBox="[\s\d\w.]+"/m;

    signaturePad!: SignaturePad;

    constructor(
        public formService: FormsService,
        public toastService: ToastService
    ) {}

    ngOnInit(): void {
        this.setCanvas();
    }

    ngAfterViewInit() {
        this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
    }

    public setCanvas = () => {
        const canvas: any = document.querySelector("canvas");
        canvas.setAttribute("width", `${window.innerWidth}`);
    };

    public drawComplete = () => {
        const dataUrl = this.signaturePad.toDataURL("image/svg+xml");
        const rawSvg = atob(dataUrl.split(",")[1]);

        const signature = rawSvg
            .replace(this.widthPattern, 'width="15cm"')
            .replace(this.heightPattern, 'height="15cm"')
            .replace(this.viewBoxPattern, "");

        this.formService.updateStateForm(this.formTemplateFieldId, "", signature);
        this.toastService.showToastMessage("TOAST.SIGNATURE_SUCCESS");
    };

    public clearPad() {
        this.signaturePad.clear();
    }

    private dataURLtoFile(dataurl) {
        const arr = dataurl.split(",");
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr]);
    }
}
